import Typography from '@/common/components/base/typography/Typography';
import OutlineInfoCircleIcon from '@/modules/Dashboard/assets/icons/outlineInfoCircle.svg?react';
import TickCircleIcon from '@/modules/Dashboard/assets/icons/tickCircle.svg?react';
import { Box, Center, Flex } from 'styled-system/jsx';
import InfoCircleIcon from '../../assets/icons/infoCircle.svg?react';
import { TMonthReportInfo } from '../../types/Wallet.types';
import CashComponent from '../cashComponent/CashComponent';

export default function YearlyReportCreditCard({
  monthInfo,
}: {
  monthInfo: TMonthReportInfo;
}) {
  const { total_amount, unpaid, fa_name, files_count } = monthInfo;
  return (
    <Flex flexDirection={'column'} gap={16} width={'100%'}>
      <Flex justifyContent={'space-between'} alignItems={'center'}>
        <Flex alignItems={'center'} gap={8}>
          <Typography fontSize={16} fontWeight={'bold'}>
            {fa_name}
          </Typography>
          {total_amount ? (
            <Typography
              bgColor={'#DEEEFF'}
              color={'#0A66C2'}
              borderRadius={50}
              textStyle={'b3'}
              px={8}
            >
              {files_count} پرونده
            </Typography>
          ) : null}
        </Flex>
        {total_amount ? (
          <CashComponent cashValue={total_amount.toString()} />
        ) : null}
      </Flex>
      {total_amount ? (
        <Flex alignItems={'center'} justifyContent={'space-between'}>
          {Boolean(unpaid) ? (
            <Flex
              py={4}
              px={14}
              gap={8}
              borderRadius={8}
              alignItems={'center'}
              justifyContent={'center'}
              bgColor={'#E9ECF2'}
              color={'#485D73'}
              mr={'auto'}
            >
              <OutlineInfoCircleIcon />
              <Center>
                <CashComponent
                  cashValue={unpaid.toString()}
                  textProps={{ fontSize: 16 }}
                  rialSize={0}
                />
                <Typography fontSize={16}>تسویه نشده</Typography>
              </Center>
            </Flex>
          ) : (
            <Flex
              alignItems={'center'}
              py={4}
              px={14}
              mr={'auto'}
              borderRadius={8}
              bgColor={'green-4'}
              gap={8}
            >
              <TickCircleIcon />
              <Typography color={'#009155'} fontSize={16}>
                تسویه شده
              </Typography>
            </Flex>
          )}
        </Flex>
      ) : (
        <Flex
          gap={8}
          p={12}
          bgColor={'gray-4'}
          color={'black-1'}
          alignItems={'center'}
          borderRadius={8}
        >
          <InfoCircleIcon />
          <Typography textStyle={'b2'} fontSize={14}>
            پرونده و تراکنش مالی ثبت نشده است.
          </Typography>
        </Flex>
      )}
      <Box width={'100%'} height={1} bgColor={'gray-2'} mt={8} />
    </Flex>
  );
}
